import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function userSelectDataReducer(
  state = initialState.userSelectData,
  action
) {
  switch (action.type) {
    case types.LOADED_USER_SELECT_SUCCESS:
      return action.userSelectData;
    default:
      return state;
  }
}
